<template>
    <div class="text-center price-nowrap">
        <span>{{ calculateTotalCost }}</span>
    </div>
</template>

<script>
import { formatMoney } from '@/lib/helper';

export default {
	name: 'PriceColumn',
	props: {
		data: {
			type: Object,
			default: () => {},
		},
		fieldKey: {
			type: String,
			default: '',
		},
	},
	computed: {
		calculateTotalCost() {
			return formatMoney(this.data[this.fieldKey]);
		},
	},
};
</script>

<style lang="scss" scoped>
	.price-nowrap {
		white-space: nowrap;
	}
</style>
